import styled from "styled-components";
import { data } from "./blogpostdata"
import { useParams } from "react-router-dom";
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton, TumblrShareButton } from "react-share";
import { faFacebook, faTwitter, faLinkedin, faTumblr } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BlogPages = styled.div`
    margin-top: 90px;
    width: 100%;
`;

const BlogContainer = styled.div`
    padding-left: 5%;
    padding-top: 5%;
    
    @media screen and (max-width: 768px){
        padding-right: 5%;
    }
`;

const TopWrapper = styled.div`
    width: 55%;
    display: grid;
    justify-content: flex-start;
    
    @media screen and (max-width: 768px){
        width: 100%;
    }
`;
const TopHeader = styled.h1`
    color: white;
    background-color: #B55959;
    height: 144px;
    font-family: "Roboto";
    font-size: 1.5em;
    display: flex;
    align-items: center;
    justify-content: center;
`; 

const Img = styled.img`
    width: 80%;
    height: auto;

    @media screen and (max-width: 768px) {
        display: flex;
        place-self: center;
        width: 100%;
    }
`;

const BlogTitle = styled.h1`
    font-size: 28px;
    font-family: "Sunflower";
    font-weight: 500;
    text-align: start;

    @media screen and (max-width: 768px){
        font-size: 16px;
    }

`;

const BlogSubtitle = styled.h2`
    color: #727272;
    font-size: 24px;
    font-weight: 400;
    font-family: "Sunflower";
    text-align: start;

    @media screen and (max-width: 768px){
        font-size: 14px;
    }
`;

const Separator =  styled.div`
    border-top: 1px solid #ccc;
    width: 100%;
    padding-bottom: 5%;
`;

const ContentWrapper = styled.div`
    width: 65%;
    text-align: start;

    @media screen and (max-width: 768px){
        width: 100%;
    }
`;

const Subheader = styled.h2`
    font-size: 18px;
    color: #9D2222;
    font-family: "Sunflower";
`;

const BlogText =styled.p`
    font-size: 18px;
    font-weight: 250;
    font-family: "Sunflower";
    color: #000;   
    
    a {
        color: #007bff;
        text-decoration: underline;
    }

    @media screen and (max-width: 768px) {
        overflow-wrap: break-word;
    }
`;

const SocialContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 5%;
    padding-left: 5%;
    gap: 1%;
`;

const SocialText = styled.h5`
    font-family: "Sunflower";
    font-weight: 500;
    font-size: 20px;
`;

const SocialRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20%;
`;

const UnorderedList = styled.ul`
    font-weight: 350;
`;

const OrderedList = styled.ol`
    font-weight: 350;
    list-style-type: decimal;
`;

const ListItem = styled.li`
    color: #000;
    font-family: "Sunflower";
`;

const BoldText = styled.span`
    font-weight: bold;
`;

const BoldAndRedText = styled.span`
    color: #9D2222;
    font-weight: bold;
`;

const BlogRow = styled.div`
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 768px){
        width: 100%;
    }
`;

const RecentPostsContainer = styled.div`
    padding-top: 5%;
	width: 25%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 5%;

  @media screen and (max-width: 768px) {
    /* order: 3;
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 5%; */
    display: none;
  }
`;

const RecentPostsHeader = styled.h3`
	background-color: #EEEEEE;
	color: #000;
	border-radius: 20px;
	width: 80%;
	height: 8%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const RecentPostItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100px;

`;

const RecentPostTitle = styled.h4`
	color: #727272;
`;

const RecentPostSubtitle = styled.h3`
    color: #727272;
`

const SeparatorLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: #ccc;
`;

const BottomSeparatorLine = styled.div`
	width: 80%;
	height: 1px;
	background-color: #ccc;
    margin-left: 5%;
`;

const RelatedPostsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 5%;

    @media screen and (max-width: 768px){
        margin-right: 5%;
    }
`;

const RelatedPostItem = styled.div`
    width: 60%;
    padding-bottom: 3%;

    @media screen and (max-width: 768px){
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
    }
`;

const RelatedPostLink = styled.a`
    text-decoration: none;
    height: 200px;
    display: "flex"; 
    align-items: "center";
    padding-bottom: "5%";

    @media screen and (max-width: 768px){
        height: auto;
        display: flex;
        flex-direction: column;
        padding-bottom: 10%;
    }

`;

const RelatedPostImg= styled.img`
    display: flex;
    width: 30%;
    padding-left: 5%;

    @media screen and (max-width: 768px){
        width: 100%;
        order: -1;
        padding-bottom: 3%;
    }
`;

const RelatedPostTitle = styled.h1`
    color: #000;
    font-family: Sunflower;
    font-size: 20px;
    padding-left: 5%;
    text-align: left;
    font-weight: 400;

    @media screen and (max-width: 768px){
        font-size: 13px;
    }
`;

const PreviewText = styled.p`
    font-size: 14px;
    font-family: Sunflower;
    font-weight: 300;
    color: #585858;
    text-align: left;
    padding-left: 5%;

    @media screen and (max-width: 768px){
        font-size: 12px;
    }
`;

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export function BlogPosts(){

    const { id } = useParams();
    const postData = data.find(blog => blog.id === parseInt(id))

    if (!postData) {
        return <div>Loading...</div>
    }
    
    const shareUrl = postData.link;
    const shareTitle = postData.title;
    const shareImage = postData.img;

    function isUrl(str){
        const urlPattern = /^(https?:\/\/)?[\w.-]+\.[a-z]{2,}(\/\S*)?$/;
        return urlPattern.test(str);
    }

    function convertTextToLinks(text) {
        return text.split(/\s+/).map((word, index) =>
          isUrl(word) ? (
            <a key={index} href={word} target="_blank" rel="noopener noreferrer">
              {word}{' '}
            </a>
          ) : (
            `${word} `
          )
        );
    }

    // function isSpecialCharacter(char) {
    //     return /[.,:-]/.test(char);
    // }

    // function formatText(text) {
    //     let encounteredSpecialChar = false;

    //     return text.split(/\s+/).map((part, index) => {
    //         const isSpecial = isSpecialCharacter(part.charAt(part.length - 1));
    //         const isFirstOccurrence = !encounteredSpecialChar && isSpecial;
      
    //         encounteredSpecialChar = encounteredSpecialChar || isSpecial;
      
    //       return [
    //         isFirstOccurrence ? (
    //           <BoldAndRedText>{part.slice(0, -1)}</BoldAndRedText>
    //         ) : (
    //           part.slice(0, -1)
    //         ),
    //         part.slice(-1)
    //       ];
    //     });
    // }
      
    function formatText(text, boldWords) {
        const isBoldPhrase = boldWords.includes(text)
        console.log(boldWords,isBoldPhrase, "lol", text)
        
        return isBoldPhrase ? (
          <BoldAndRedText>{text}</BoldAndRedText>
        ) : (
          <span>{text}</span>
        );
      }      
      
      
      


      
    
    function renderList(list, isOrdered, boldWords) {
        return isOrdered ? (
          <OrderedList>
            {list.map((item, itemIndex) => (
              <ListItem key={itemIndex}>
                <BoldText>{item.split(': ')[0]}:</BoldText> {item.split(': ')[1]}
              </ListItem>
            ))}
          </OrderedList>
        ) : (
          <UnorderedList>
            {list.map((item, itemIndex) => (
              <ListItem key={itemIndex}>
                {item.includes(':') ? (
                  <>
                    <BoldText>{item.split(': ')[0]}:</BoldText> {item.split(': ')[1]}
                    {formatText(item, boldWords)}
                  </>
                ) : (
                  formatText(item, boldWords)
                )}
              </ListItem>
            ))}
          </UnorderedList>
        );
    }

    
    
    return(
        <BlogPages>
            <TopHeader>The Exp Recruiting Blog</TopHeader>
            <BlogContainer>
                <BlogRow>
                    <TopWrapper id="top-wrapper">
                        <Img  src={postData.img} alt={postData.title}/>
                        <BlogTitle>{postData.title}</BlogTitle>
                        {postData.subtitle && <BlogSubtitle>{postData.subtitle}</BlogSubtitle>}
                        <Separator />
                    </TopWrapper>
                    <RecentPostsContainer>
                        <RecentPostsHeader>RECENT POSTS</RecentPostsHeader>
                        {data.slice(0,3).map((post) => (
                            <RecentPostItem key={post.id}>
                                <a href={`/blog/${post.id}`} style={{textDecoration: "none", height: "99px", display: "flex", alignItems: "center"}}>
                                    <RecentPostTitle>{post.title}</RecentPostTitle>
                                    {/* {post.subtitle && <RecentPostSubtitle>{post.subtitle}</RecentPostSubtitle>} */}
                                </a>
                                <SeparatorLine />
                            </RecentPostItem>
                        ))}
                </RecentPostsContainer>
                </BlogRow>
                <ContentWrapper id="content-wrapper">
                {postData.content.map((section, index) => (
                    <div id="blog-text">
                        {section.subheader && <Subheader>{section.subheader}</Subheader>}
                        {section.text && <BlogText>{convertTextToLinks(section.text,)}</BlogText>}
                        {section.list && renderList(section.list, section.isOrdered, section.boldWords || [])}
                    </div>
                ))}
                </ContentWrapper>
            </BlogContainer>
            <SocialContainer>
                <SocialText>Share This Post</SocialText>
                <SocialRow>
                    <FacebookShareButton
                        url={shareUrl}
                        title={shareTitle}
                        img={shareImage}
                    >
                        <FontAwesomeIcon icon={faFacebook}/>
                    </FacebookShareButton>
                    <TwitterShareButton
                        url={shareUrl}
                        title={shareTitle}
                        img={shareImage}
                    >
                        <FontAwesomeIcon icon={faTwitter}/>
                    </TwitterShareButton>
                    <LinkedinShareButton
                        url={shareUrl}
                        title={shareTitle}
                        img={shareImage}
                    >
                        <FontAwesomeIcon icon={faLinkedin}/>
                    </LinkedinShareButton>
                    <TumblrShareButton
                        url={shareUrl}
                        title={shareTitle}
                        img={shareImage}
                    >
                        <FontAwesomeIcon icon={faTumblr}/>
                    </TumblrShareButton>
                </SocialRow>
            </SocialContainer>
            <BottomSeparatorLine />
            <RelatedPostsContainer id="related-post-container">
            <h1 style={{color: "#000", fontFamily: "Roboto", fontSize: "20px", fontWeight: "300", textAlign: "left", paddingBottom: "3%", paddingTop: "2%"}}>Related Posts</h1>
                {data.slice(0, 2).filter(post => post.id !== post).map((post) =>(
                    <RelatedPostItem key={post.id} id="related-post-item">
                        <RelatedPostLink href={`/blog/${post.id}`}>
                            <RelatedPostImg src={post.img}/>
                            <TextWrapper id="text-wrapper">
                                <RelatedPostTitle>{post.title}</RelatedPostTitle>
                                <PreviewText>
                                    {post.content[0].text.split(" ").slice(0, 15).join(" ")}...
                                </PreviewText>
                            </TextWrapper>
                        </RelatedPostLink>
                    </RelatedPostItem>
                ))}
            </RelatedPostsContainer>
        </BlogPages>
    )
}